export default __webpack_public_path__ + "static/media/card-m-app@3x.8c0a158e.png";